import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import { StylableComponent, stylePropType } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';

import Badge from './Badge';

export const BimColors = {
  BLUE: 'blue',
  YELLOW: 'yellow',
  GREEN: 'green',
  PURPLE: 'purple',
  RED: 'red',
  GRAY: 'gray',
  GRAY_DARK: 'gray-dark',
} as const;

const mapBimColorsToAlloy: Record<string, string> = {
  [BimColors.BLUE]: theme.colors.adskBlue500,
  [BimColors.YELLOW]: theme.colors.yellowOrange500,
  [BimColors.GREEN]: theme.colors.green500,
  [BimColors.RED]: theme.colors.red500,
  [BimColors.GRAY]: theme.colors.charcoal400,
  [BimColors.GRAY_DARK]: theme.colors.charcoal500,
} as const;

type BadgeBimAdapterProps = StylableComponent<HTMLSpanElement> & {
  label: ReactNode;
  color: keyof typeof mapBimColorsToAlloy;
};

const BadgeBimAdapter: FC<BadgeBimAdapterProps> = ({
  style,
  label,
  className,
  color,
  ...props
}) => {
  return (
    <Badge
      color={mapBimColorsToAlloy[color] || theme.colors.adskBlue500}
      style={style}
      className={className}
      {...props}
    >
      {label}
    </Badge>
  );
};

BadgeBimAdapter.propTypes = {
  style: stylePropType,
  className: PropTypes.string,
  label: PropTypes.node.isRequired,
  color: PropTypes.oneOf(Object.values(BimColors)).isRequired,
};

export default Object.assign(BadgeBimAdapter, { Colors: BimColors });
